module.exports = __webpack_public_path__ + "img/chameleon-2712355_1920.a7b544dc.jpg";